export { default } from './PaymentAuthentications.container';
